import { Menu as MantineMenu, MenuProps as MantineMenuProps } from '@mantine/core';
import { JSX } from 'react';
import styles from './Menu.module.css';

export type MenuProps = MantineMenuProps;

/**
 * Use Object.assign to add the static properties of MantineMenu to the Menu component
 * This is necessary because Menu is a functional component and does not have static properties by default.
 * This allows us to use the Menu.Target, Menu.Dropdown, Menu.Item, Menu.Divider, and Menu.Label components as static properties of the Menu component.
 */
export const Menu: typeof MantineMenu & {
    (props: MenuProps): JSX.Element;
} = Object.assign(({ children, classNames, ...props }: MenuProps) => {
    return (
        <MantineMenu
            classNames={{
                dropdown: styles.dropdown,
                item: styles.item,
                divider: styles.divider,
                label: styles.label,
                itemLabel: styles.itemLabel,
                ...classNames,
            }}
            {...props}
        >
            {children}
        </MantineMenu>
    );
}, MantineMenu);
